import { Block } from 'factories/block';
import getBlockById from './apiHelpers/getBlockById';

const findByKeyVal = (o, key, val) => {
  if (o[key] && o[key] === val) return o;
  let result;
  for (const p in o) {
    if (o.hasOwnProperty(p) && typeof o[p] === 'object') {
      result = findByKeyVal(o[p], key, val);
      if (result) {
        return result;
      }
    }
  }
};

export default findByKeyVal;

export const findByKeyVal_V2 = (
  rootId: string,
  type: string,
  val: string
): Block | undefined => {
  const root = getBlockById(rootId);

  if (!root) {
    return undefined;
  }

  if (root[type] === val) {
    return root;
  }

  let found: Block | undefined = undefined;
  if (Array.isArray(root.children)) {
    root.children.forEach(c => {
      const block = findByKeyVal_V2(c.id, type, val);
      if (block) {
        found = block;
      }
    });
  }

  return found;
};
